import React from 'react';

const Button = ({ buttonType, disabled, clicked, children, type }) => (
  <button
    className={buttonType}
    disabled={disabled ? 'disabled' : undefined}
    onClick={clicked}
    type={type}>
    {children}
  </button>
);

export default Button;
